<div
  #container
  class="wrapper"
  [ngClass]="currentDirection()"
  (window:mousemove)="onDrag($event)"
  (window:mouseup)="onDragEnd()"
>
  <div class="box box-a" [style]="styleA()">
    <ng-content select="[boxA]"></ng-content>
  </div>
  @if (direction() !== 'none') {
    <div class="separator" (mousedown)="onDragStart($event)">
      <div class="separator-zone"></div>
    </div>
    <div class="box box-b" [style]="styleB()">
      <ng-content select="[boxB]"></ng-content>
    </div>
  }
</div>
